// Shared constants for 2Y3X methodology

export const PERSPECTIVE_COLORS: Record<string, { bg: string; text: string; code: string }> = {
  'People': { bg: 'bg-purple-100', text: 'text-purple-700', code: 'PE' },
  'Customers': { bg: 'bg-blue-100', text: 'text-blue-700', code: 'CU' },
  'Sales & Marketing': { bg: 'bg-pink-100', text: 'text-pink-700', code: 'SM' },
  'Processes': { bg: 'bg-green-100', text: 'text-green-700', code: 'PR' },
  'Corp & £': { bg: 'bg-amber-100', text: 'text-amber-700', code: 'CF' },
};

export const AREA_OPTIONS = [
  "People",
  "Customers",
  "Sales & Marketing",
  "Processes",
  "Corp & £"
];

// Helper function to get area display label with dynamic currency
export const getAreaDisplayLabel = (area: string, currencySymbol: string): string => {
  if (area === 'Corp & £') {
    return `Corp & ${currencySymbol}`;
  }
  return area;
};

// Helper function to get area options with dynamic currency
export const getAreaOptions = (currencySymbol: string): string[] => {
  return AREA_OPTIONS.map(option => 
    option === 'Corp & £' ? `Corp & ${currencySymbol}` : option
  );
};
